@if (rescaleAll$ | async) {
  <button
    mat-icon-button
    (click)="toggleRescaleAllFrames(false)"
    matTooltip="Sizing edits on all frames"
  >
    <mat-icon svgIcon="rescaleAll"></mat-icon>
  </button>
} @else {
  <button
    mat-icon-button
    (click)="toggleRescaleAllFrames(true)"
    matTooltip="Sizing edits on current frame"
  >
    <mat-icon svgIcon="rescaleCurrentFrame"></mat-icon>
  </button>
}
